// extracted by mini-css-extract-plugin
export default {"sortByDesktop":"SortBy_sortByDesktop__3vXlv","sortByMenuLabel":"SortBy_sortByMenuLabel__q79+d"};